module.exports = __webpack_public_path__ + "img/two.84ef7be4.png";